(function () {
  'use strict';
  var gyms = ['forfar', 'arbroath', 'kirriemuir', 'blairgowrie'];
  var labels = ['Forfar', 'Arbroath', 'Kirriemuir', 'Blairgowrie'];
  var intents = { tour: 'Book a free tour', induction: 'Book an induction', class: 'Try a class', fitness: 'Fitness class', 'adult-kickboxing': 'Adult kickboxing', 'adult-grappling': 'Adult grappling', 'kids-kickboxing': 'Kids kickboxing', 'kids-grappling': 'Kids grappling', reset21: 'Reset 21', membership: 'Membership question', coaching: 'Coaching advice', pt: 'Personal training', general: 'General enquiry' };

  function getEnquiryContext(search) {
    var params = new URLSearchParams(search);
    var gym = (params.get('gym') || '').toLowerCase();
    var intent = params.get('intent') || '';
    return {
      gym: gyms.includes(gym) ? labels[gyms.indexOf(gym)] : '',
      intent: Object.prototype.hasOwnProperty.call(intents, intent) ? intents[intent] : ''
    };
  }
  var jotformIntents = { 'Book a free tour': 'Tour', 'Book an induction': 'Induction', 'Try a class': 'Help choosing a class', 'Fitness class': 'Fitness class', 'Adult kickboxing': 'Adult kickboxing', 'Adult grappling': 'Adult grappling', 'Kids kickboxing': 'Kids kickboxing', 'Kids grappling': 'Kids grappling', 'Reset 21': 'Reset 21', 'Membership question': 'Membership question', 'Coaching advice': 'Help choosing coaching', 'Personal training': 'Personal training', 'General enquiry': 'Something else' };

  function getJotformURL(search) {
    var context = getEnquiryContext(search);
    var url = new URL('https://form.jotform.com/262883833005055');
    url.searchParams.set('websiteSource', 'Website');
    url.searchParams.set('sourcePage', '/pages/contact');
    if (context.gym) url.searchParams.set('q5_dropdown3', context.gym);
    if (context.intent) url.searchParams.set('q6_dropdown4', jotformIntents[context.intent]);
    return url.href;
  }
  if (typeof module === 'object' && module.exports) module.exports = { getEnquiryContext: getEnquiryContext, getJotformURL: getJotformURL };
  if (typeof document === 'undefined') return;

  function initContact() {
    var frame = document.querySelector('[data-rg-enquiry-frame]');
    if (!frame) return;
    var directLink = document.querySelector('[data-rg-enquiry-link]');
    var loading = document.querySelector('[data-rg-enquiry-loading]');
    var destination = getJotformURL(location.search);
    if (directLink) directLink.href = destination;
    frame.addEventListener('load', function () {
      if (loading) loading.hidden = true;
    });
    frame.addEventListener('error', function () {
      if (loading) loading.textContent = 'Please use the direct enquiry link above to send your request.';
    });
    // Accept resize messages only from this form's own frame and Jotform origins.
    window.addEventListener('message', function (event) {
      if (event.source !== frame.contentWindow || !['https://form.jotform.com', 'https://eu.jotform.com', 'https://www.jotform.com'].includes(event.origin)) return;
      if (typeof event.data !== 'string') return;
      var message = event.data.split(':');
      if (message[0] !== 'setHeight' || !/^\d+$/.test(message[1] || '')) return;
      var height = Number(message[1]);
      if (height >= 300 && height <= 10000) frame.style.height = (height + 24) + 'px';
    });
    // Only allowlisted gym/type values reach Jotform, never the page's other parameters.
    frame.src = destination;
    frame.hidden = false;
    window.setTimeout(function () {
      if (loading && !loading.hidden) loading.textContent = 'If the form is slow to load, please use the direct enquiry link above.';
    }, 12000);
  }

  function initTimetables() {
    var root = document.querySelector('[data-rg-timetables]');
    if (!root) return;
    var panels = Array.from(root.querySelectorAll('[data-rg-timetable]'));
    var links = Array.from(root.querySelectorAll('.rg-timetable-nav a'));
    function show(hash) {
      var selected = panels.find(function (panel) { return '#' + panel.id === hash; }) || panels[0];
      panels.forEach(function (panel) { panel.hidden = panel !== selected; });
      links.forEach(function (link) {
        if (link.hash === '#' + selected.id) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      return selected;
    }
    function syncHash(scroll) {
      var panel = show(location.hash);
      if (scroll && location.hash === '#' + panel.id) panel.scrollIntoView({block: 'start', behavior: 'instant'});
    }
    syncHash(true);
    window.addEventListener('hashchange', function () { syncHash(true); });
    links.forEach(function (link) {
      link.addEventListener('click', function () { show(link.hash); });
    });
  }
  function initWeeklySchedules() {
    var schedules = Array.from(document.querySelectorAll('.rg-weekly-text'));
    if (!schedules.length) return;
    var phone = window.matchMedia('(max-width: 749px)');
    schedules.forEach(function (schedule) {
      var days = Array.from(schedule.querySelectorAll('.rg-weekly-day'));
      days.forEach(function (day) {
        // Keep one day expanded in browsers without native details grouping.
        day.addEventListener('toggle', function () {
          if (day.open) days.forEach(function (other) { if (other !== day) other.open = false; });
        });
      });
    });
    function update() { schedules.forEach(function (schedule) { schedule.open = phone.matches; }); }
    update();
    phone.addEventListener('change', update);
  }
  function init() { initContact(); initTimetables(); initWeeklySchedules(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
